import { useEffect, useRef, ReactNode, MouseEvent } from 'react';
import { Capacitor } from '@capacitor/core';

import style from './style.module.css';
import { setSafeAreaBackgroundColor } from '../../utilities/systemBars';

interface CustomImage {
    Image?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    className?: string;
}

interface WindowProps {
    children?: ReactNode;
    isOpened?: boolean;
    customImage: CustomImage;
    safeAreaColor?: string; // Couleur de fond de la safe area (encoche/cutout) quand la fenêtre est ouverte
}

const Window = ({
    children,
    customImage,
    isOpened = false,
    safeAreaColor = '#FFFFFF'
}: WindowProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const isMobile = Capacitor.isNativePlatform();
    // const mouseDownTarget = useRef<EventTarget | null>(null);

    useEffect(() => {
        document.body.style.overflow = isOpened ? 'hidden' : '';
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpened]);

    // Colorer la safe area (encoche/cutout) pendant l'ouverture de la fenêtre
    useEffect(() => {
        if (!isMobile) return;

        setSafeAreaBackgroundColor(isOpened ? safeAreaColor : 'transparent');
    }, [isOpened, isMobile, safeAreaColor]);

    return (
        <div
            className={`${style.bgd} ${isOpened ? style.opened : ''}`}
            // Uncomment the following lines to close the window when clicking outside of it
            /*onMouseUp={(event) => {
                if (
                    mouseDownTarget.current &&
                    ref.current &&
                    !ref.current.contains(mouseDownTarget.current as Node) &&
                    !ref.current.contains(event.target as Node)
                ) {
                    onClose(event);
                }
            }}
            onMouseDown={(event) => {
                mouseDownTarget.current = event.target;
            }}*/
        >
            <div className={style.window} ref={ref}>
                <div className={style.content}>{children}</div>
            </div>
            {customImage?.Image && (
                <customImage.Image className={[style.custom, customImage.className].join(' ')} />
            )}
        </div>
    );
};

export default Window;
